<template>
    <div>

         <div class="mt-6 flex items-center justify-between px-6">
        <h4>VIEW DETAILS</h4>
        <feather-icon icon="XIcon" class="cursor-pointer" 
                  @click.stop="isSidebarActiveLocal = false"

       />
      </div>
      <vs-divider class="mb-0" />
      <div class="activity_timeline_holder">
        <table v-if=" get_leads_sidebar_data && get_leads_sidebar_data.basic_details" class="pl-5 mt-5 staff_sidebar_table" style="width: 100%;">
          <tr>
            <td>Name:</td>

            <td>
              <span
              v-if="get_leads_sidebar_data.basic_details"
                style="font-weight: 700"
              >{{ get_leads_sidebar_data.basic_details.first_name +' '+ get_leads_sidebar_data.basic_details.last_name}}</span>
             <!-- <pre> {{get_leads_sidebar_data}}</pre> -->
            </td>
          </tr>
          <tr>
            <td>Email:</td>
            <td>
              <span style="font-weight: 700"
              v-if="get_leads_sidebar_data.basic_details"
              >{{ get_leads_sidebar_data.basic_details.email.email }}</span>
            </td>
          </tr>
          <tr>
            <td>Phone:</td>
            <td>
              <span style="font-weight: 700"
              v-if="get_leads_sidebar_data.basic_details.phone"
              >{{ get_leads_sidebar_data.basic_details.phone.phone }}</span>
            </td>
          </tr>
          <tr>
            <td>Role:</td>
            <td>
              <span
                style="font-weight: 700"
              >{{ get_leads_sidebar_data.basic_details.roles[0].role_name }}</span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.basic_details.address">
            <td>Address 1:</td>
            <td>
              <span
                style="font-weight: 700"
              >{{ get_leads_sidebar_data.basic_details.address.address1 }}</span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.basic_details.address">
            <td>Address 2:</td>
            <td>
              <span
                style="font-weight: 700"
              >{{ get_leads_sidebar_data.basic_details.address.address2 }}</span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.basic_details.address">
            <td>County/State:</td>
            <td>
              <span style="font-weight: 700">{{ get_leads_sidebar_data.basic_details.address.state }}</span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.basic_details.address">
            <td>City:</td>
            <td>
              <span style="font-weight: 700">{{ get_leads_sidebar_data.basic_details.address.city }}</span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.basic_details.address">
            <td>Postcode/Zip:</td>
            <td>
              <span style="font-weight: 700">{{ get_leads_sidebar_data.basic_details.address.zip }}</span>
            </td>
          </tr>
          <tr>
            <td>Created At:</td>
            <td>
              <span style="font-weight: 700">{{get_leads_sidebar_data.basic_details.created_at | dateFormatLocalization}}</span>
            </td>
          </tr>
        </table>

        <vs-divider class="mb-0" />

        <activity-timeline :no_shadow="true" :staff_id="get_leads_sidebar_data.basic_details.operation_user_id" />
      </div>
    </div>
</template>

<script>
import activityTimeline from './ActivityTimeline.vue'

export default {
    
  components:{
    activityTimeline
  },
  computed:{
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        
        if (!val) {
          
          this.$emit('closeSidebar')
        }
      }
    }
  },
  props:{
    isSidebarActive:{},
    get_leads_sidebar_data:{
      /*  type:Object,
      required:true,
      default:() => {} */
    },
    timelineData:{
      type:Array,
      required:true,
      default:() => []
    }
  },
  methods:{
    handleViewSidebar () {
      this.isSidebarActive = false
    //   this.$emit('closeSidebar')
    }
  }
}
</script>


<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

body {
  margin: 0;
}

.example-list-item {
  margin: 0;
  padding: 0 10px;
  font-size: 14px;
  line-height: 40px;
  color: #666;
  background-color: #fafafa;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #e3e3e3;
}

.example-list-item::before {
  content: "Line: ";
}

.con-vs-dialog .vs-dialog {
  z-index: 3000000000000000000000;
}
li {
  list-style: none;
}
</style>
<style>
.staff_sidebar_table td{
  padding: 10px 0;
}
.activity_timeline_holder {
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>